module.exports = __webpack_public_path__ + "img/cat-4.9fdb94d0.svg";